import { css } from '@emotion/react';
import { applyFont, tokens } from '@domain-group/fe-brary';
import { media } from '../../styles/breakpoints-2026';

const { spacing, colors, borderRadius, typography } = tokens;

const AVATAR_SIZE = 64;

export const modalOverride = css`
  ${media('<tablet')} {
    background: ${colors.neutral.surface.default} !important;
    padding: 0 !important;
  }
`;

export const modalWindow = css`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 725px;
  max-height: 90vh;
  overflow-y: auto;
  background: ${colors.neutral.surface.default};
  border-radius: ${borderRadius.mini};

  ${media('<tablet')} {
    width: 100vw;
    height: 100vh;
    max-height: 100vh;
    border-radius: 0;
  }
`;

// Wraps the checkbox/message/contact-detail columns + T&Cs - matches
// Figma's "Enquiries" container padding (more horizontal than the header,
// less on top since the header row above already carries its own gap).
export const enquiriesSection = css`
  display: flex;
  flex-direction: column;
  gap: ${spacing.l};
  padding: ${spacing.m};
`;

export const successSection = css`
  display: flex;
  flex-direction: column;
  gap: ${spacing.xl};
  padding: ${spacing.xxl} ${spacing.xl} ${spacing.xl};
`;

export const header = css`
  display: flex;
  flex-direction: column;
  gap: ${spacing.l};
  padding: ${spacing.m};
`;

export const headerIdentity = css`
  display: flex;
  align-items: center;
  gap: ${spacing.s};
  width: 100%;
`;

export const avatarImage = css`
  width: ${AVATAR_SIZE}px;
  height: ${AVATAR_SIZE}px;
  border-radius: ${borderRadius.inner};
  flex-shrink: 0;

  ${media('<tablet')} {
    width: 48px;
    height: 48px;
  }
`;

export const avatarPlaceholder = css`
  ${avatarImage};
  position: relative;
  overflow: hidden;
  background: ${colors.neutral.subdued.default};
`;

export const avatarPlaceholderIcon = css`
  position: absolute;
  top: 18.18%;
  right: 9%;
  bottom: -2.27%;
  left: 9.4%;
  width: auto;
  height: auto;
  color: ${colors.secondary.trim.hover};
`;

export const headerDetails = css`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
`;

// Not a flex container - see the usage comment for why this exists.
export const headerPhone = css`
  flex-shrink: 0;
`;

export const heading = css`
  ${applyFont(typography.heading)}
  color: ${colors.neutral.heavy.default};
  margin: 0;
`;

export const headerJobTitle = css`
  ${applyFont(typography.body)}
  color: ${colors.neutral.heavy.default};
  margin: 0;
`;

export const subheading = css`
  ${applyFont(typography.caption)}
  color: ${colors.neutral.medium.default};
  margin: 0;
`;

export const groupLabel = css`
  ${applyFont(typography.overline)}
  color: ${colors.neutral.medium.default};
  margin: 0 0 ${spacing.xs} 0;
`;

export const groupLabelNoDivider = css`
  ${applyFont(typography.overline)}
  color: ${colors.neutral.medium.default};
  margin: 0 0 ${spacing.s} 0;
`;

export const groupDivider = css`
  border: none;
  border-top: 1px solid ${colors.neutral.trim.default};
  margin: ${spacing.s} 0 ${spacing.m} 0;
`;

export const checkboxItem = css`
  margin: ${spacing.xs} 0;
`;

export const section = css`
  margin-bottom: ${spacing.xs};

  &:last-child {
    margin-bottom: 0;
  }

  .input-wrapper__errors:not(:empty) {
    margin-bottom: ${spacing.s};
  }
`;

export const formColumns = css`
  display: flex;
  flex-direction: column;
  gap: ${spacing.m};

  ${media('>tablet-narrow')} {
    flex-direction: row;
  }
`;

export const formColumn = css`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
`;

export const errorBanner = css`
  ${media('<tablet')} {
    order: -1;
  }
`;

export const submitButton = css`
  width: 100%;
`;

export const sendingPlaceholder = css`
  min-height: 360px;
  padding: ${spacing.l};
`;

export const successHeading = css`
  ${applyFont(typography.heading)}
  color: ${colors.neutral.heavy.default};
  text-align: center;
  margin: 0;
`;

export const successDriver = css`
  display: flex;
  align-items: center;
  gap: ${spacing.m};
  padding: ${spacing.s} ${spacing.xl};
`;

export const successCopy = css`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${spacing.xxs};
  flex: 1;
  min-width: 0;
`;

export const successCrossSell = css`
  ${applyFont(typography.body)}
  color: ${colors.neutral.medium.default};
  margin: 0;
`;

export const successCtaGroup = css`
  display: flex;
  justify-content: flex-end;
  gap: ${spacing.s};

  ${media('<tablet')} {
    flex-direction: column-reverse;

    button,
    a {
      width: 100%;
    }
  }
`;
